<script>
  import ProtectedRoute from "./ProtectedRoute.svelte";

  let userData = localStorage.getItem("userData");
  let isSidebarOpen = true;

  if (userData) {
    userData = JSON.parse(userData);
  }

  function toggleSidebar() {
    isSidebarOpen = !isSidebarOpen;
  }

  function handleClick() {
    if (!userData) {
      return;
    }
    // console.log("Search by? clicked");
  }
</script>

{#if isSidebarOpen}
  <div class="sidebar" on:mouseleave>
    <ul>
      <div style="text-align: center;">
        <img
          src="/PrimaryLogo.png"
          alt="TruLens"
          style="width: 150px; height: auto; background-color: #ffffff;"
        />
      </div>
      <li><a href="#/landing">Landing</a></li>
      <li><a href="/">Home</a></li>
      {#if userData}
        <li><a href="#/uploads">My Uploads</a></li>
        <li><a href="#/subscription-posts">Subscriptions</a></li>
      {/if}
      <li>
        <!-- svelte-ignore a11y-invalid-attribute -->
        <a
          href="#"
          class={userData ? "" : "disabled"}
          on:click|preventDefault={handleClick}
        >
          Search by?
        </a>
        <ul>
          <li><a href="#/location">Location</a></li>
          <li><a href="#/datetime">Date and Time</a></li>
          <li><a href="#/location-datetime">Location, Date and Time</a></li>
        </ul>
      </li>
      {#if userData}
        <li><a href="#/qr">Camera Verification</a></li>
        <li><a href="#/2fa">Two Factor Authentication</a></li>
      {/if}
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <li><p class="close-btn" on:click={toggleSidebar}>CLOSE</p></li>
    </ul>
  </div>
{/if}

<style>
  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 250px;
    background-color: white;
    z-index: 1;
    overflow-y: auto;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.6);

    display: flex;
    flex-direction: column;
    /* justify-content: center; */
  }

  a.disabled {
    color: #999;
    pointer-events: none;
    cursor: default;
    text-decoration: none;
  }

  li ul {
    display: none;
  }

  li:hover > ul {
    display: block;
  }

  li ul li {
    display: block;
    font-size: 11px;
  }

  li ul li a {
    display: block;
    /* padding: 10px; */
    text-decoration: none;
    color: #333;
  }

  li ul li a:hover {
    background-color: #f0f0f0;
  }

  .sidebar ul {
    list-style-type: none;
    padding: 0;
  }

  .sidebar ul li {
    padding: 10px;
    border-bottom: 3px solid #ddd;
    text-align: center;
    font-weight: bold;
  }

  .sidebar ul li:last-child {
    border-bottom: none;
  }

  .sidebar ul li a {
    text-decoration: none;
    color: #333;
  }

  .sidebar ul li a:hover {
    color: #ff3c82;
  }

  .close-btn {
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
    align-self: flex-end;
    margin: 10px;
  }

  @media (max-width: 768px) {
    .sidebar {
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      overflow-y: auto;
      box-shadow: 2px 0 5px rgba(0, 0, 0, 0.6);
      display: flex;
      flex-direction: column;
      /* justify-content: center; */
    }
  }
</style>
